import React from 'react';
import { isEmpty } from 'lodash';
import { isRTL } from '../../../../common/utils/commonHelper';

export function getInputDirection(value, placeholder) {
  const text = !isEmpty(value) ? value : placeholder;
  return isRTL(text) ? 'rtl' : 'ltr';
}

export function withInputDirection(WrappedComponent) {
  return class WithInputDirection extends React.PureComponent {
    getDirection = () => {
      const { value, placeholder } = this.props;
      return getInputDirection(value, placeholder);
    };

    render() {
      const dir = this.getDirection();
      const { inputProps = {}, ...rest } = this.props;
      const mergedInputProps = { ...inputProps, dir };
      return <WrappedComponent {...rest} inputProps={mergedInputProps} />;
    }
  };
}
